// @ts-nocheck

export const KL_COUNTER_PENDING_HALO_BORDER_LENGTH = 0.3; // em
export const KL_BADGE_HALO_DURATION = 3500; // ms
